import "./SideBar.css";
import React, { useContext, useState } from "react";
import SideListItem from "../../../Molecules/SideListItem/SideListItem";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import LocationCityRoundedIcon from "@mui/icons-material/LocationCityRounded";
import AutoStoriesRoundedIcon from "@mui/icons-material/AutoStoriesRounded";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { userContext } from "../../../../Contexts/userContext";
import PaymentIcon from "@mui/icons-material/Payment";
import PersonIcon from "@mui/icons-material/Person";

function SideBar({ setShowMenu }) {
  const { contextData, setContextData } = useContext(userContext);

  return (
    <div className="SideBar" id="SideBar">
      <ul className="TabList">
        <SideListItem
          name={"account"}
          Pathname={"/"}
          title="Account"
          icon={<AccountCircleIcon className="ListIcon" />}
          setShowMenu={setShowMenu}
        />
        <SideListItem
          onClick={() => setShowMenu(false)}
          name={"pricing"}
          Pathname={"/pricing"}
          title="Pricing"
          icon={<PaymentIcon className="ListIcon" />}
          setShowMenu={setShowMenu}
          arrowRotate={contextData?.data && contextData?.page == "pricing"}
        />
        <SideListItem
          name={"teams"}
          Pathname={"/teams"}
          title="Teams"
          icon={<PeopleAltRoundedIcon className="ListIcon" />}
          setShowMenu={setShowMenu}
          arrowRotate={contextData?.data && contextData?.page == "teams"}
        />
        <SideListItem
          name={"members"}
          Pathname={"/members"}
          title="Members"
          icon={<PersonIcon className="ListIcon" />}
          setShowMenu={setShowMenu}
          arrowRotate={contextData?.data && contextData?.page == "members"}
        />
        <SideListItem
          name={"coaches"}
          Pathname={"/coaches"}
          title="Coaches"
          icon={<AutoStoriesRoundedIcon className="ListIcon" />}
          setShowMenu={setShowMenu}
          arrowRotate={contextData?.data && contextData?.page == "coaches"}
        />
        <SideListItem
          name={"transactions"}
          Pathname={"/transactions"}
          title="Transactions"
          icon={<PaymentIcon className="ListIcon" />}
          setShowMenu={setShowMenu}
          arrowRotate={contextData?.data && contextData?.page == "transactions"}
        />
      </ul>
    </div>
  );
}

export default SideBar;
